import React, { useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { LayersIcon } from '@assets/icons/map/Layers';
import { List } from 'antd';
import { observer } from 'mobx-react';
import { CardItem } from './CardItem';
import { RecordCardManager } from '../../../store/shared/RecordCardManager';
import { Card } from '../../../store/LinkController/Card';

import '@assets/scss/index.scss';
import './style.scss';

export interface CardCollectionViewProps {
  recordCardManager: RecordCardManager;
  recordCard: Card;
}

export const CardCollection: React.FC<CardCollectionViewProps> = observer(
  function CardCollection({ recordCardManager, recordCard }) {
    const [isVisible, setIsVisible] = useState(false);

    const { collection } = recordCardManager;

    if (collection.length === 0) return null;

    return (
      <div className="card-collection">
        <div
          className={
            isVisible
              ? 'card-collection-header active'
              : 'card-collection-header'
          }
          onClick={() => setIsVisible(!isVisible)}
        >
          <LayersIcon />
          <span style={{ fontFamily: 'Golos UI' }}>Карточки объектов</span>
          {isVisible ? <DownOutlined /> : <UpOutlined />}
        </div>
        {isVisible && (
          <div className="card-collection-content">
            <List size={'large'}>
              {collection.map((card) => {
                const { partition, name } = card.cardInfo;

                return (
                  <CardItem
                    key={`${partition}-${name}`}
                    recordCard={card}
                    activeCard={recordCard}
                    cardCollection={recordCardManager}
                  />
                );
              })}
            </List>
          </div>
        )}
      </div>
    );
  },
);
